import { Html, Icf, IcfCategory } from "../assessment";

/**
 * The overall assessment score goes into the report.
 */
export interface AssessmentScoring {
    sided: Sided;
    /**
     * The categories the score should be mapped to.
     */
    icfCategories: IcfCategory[]
}

/**
 * Each task is scored with points, but goes into the report individually.
 */
export interface TaskPointScoring {
    scoreMapping: ScoreMapping;
    sided: Sided;
    tasks: Task[];
}

/**
 * Signals whether the assessments is sided (distinguishes left and right values) or not (just one value).
 */
export type Sided = boolean;

/**
 * A mapping of scores to IcfLevels. If scores[1] === Icf.Level2, then a score of 1 corresponds to an ICL level of 2.
 */
export type ScoreMapping = Icf[];

/**
 * Determines the highest valid score from a PointScoring.
 */
export function getMaxScore(scoreMapping: ScoreMapping): number {
    return scoreMapping.length - 1;
}

export interface Task {
    name: string;
    taskReference?: Html;
    icfCategories: IcfCategory[]
}

